/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ProductUnion } from "../../../../types/ProductUnion";
import { FormElementPropsWithoutProduct } from "../../../../components/Case/CaseForm/FormElement";
import _ from "lodash";

export const getCourtAppointmentFields = (product: ProductUnion) => {
  let courtAppointmentFields: FormElementPropsWithoutProduct[] = [];
  _.forEach(product.courtAppointments, (courtAppointment, index) => {
    courtAppointmentFields.push(
      {
        type: "ValidatorDateField",
        path: `${product.productClassName}.courtAppointments[${index}].courtDate.appointmentDate`,
        translationPath: "courtAppointment.courtDate.appointmentDate",
        isDisabled: () => true,
      },
      {
        type: "ValidatorTextField",
        path: `${product.productClassName}.courtAppointments[${index}].courtDate.appointmentTime`,
        translationPath: "courtAppointment.courtDate.appointmentTime",
        isDisabled: () => true,
      },
      {
        type: "ValidatorSelect",
        path: `${product.productClassName}.courtAppointments[${index}].courtDateType`,
        translationPath: "courtAppointment.courtDateType",
        options: () => [
          { value: "hearing" },
          { value: "hearingOfEvidence" },
          { value: "settlement" },
          { value: "trialEmploymentLaw" },
          //{ value: "trialTenancyLaw" },
          { value: "trialTrafficLaw" },
          { value: "divorce" },
        ],
        isDisabled: () => true,
      }
    );
  });
  return courtAppointmentFields;
};
